var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1820px",
    height: "1820px",
    viewBox: "0 0 1820 1820",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#8898AA",
    strokeWidth: 100,
    cx: 910,
    cy: 910,
    r: 860
  }), /*#__PURE__*/React.createElement("g", {
    id: "face-agent",
    transform: "translate(387.000000, 435.000000)",
    fill: "#8898AA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M873.62,618.731278 C891.9075,574.312225 901.835,526.757709 901.835,474.5 C901.835,436.874449 896.0875,400.81663 886.16,367.371696 C852.1975,375.210352 816.6675,379.390969 779.57,379.390969 C619.685,379.390969 478.0875,300.481828 391.875,178.721366 C345.3725,291.598018 256.5475,383.571586 144.7325,433.738987 C142.6425,446.803414 142.6425,460.912996 142.6425,474.5 C142.6425,684.320458 312.710496,854.413546 522.5,854.413546 C577.3625,854.413546 630.135,842.394273 677.6825,820.968612 C707.465,877.929515 721.05,906.148678 720.005,906.148678 C634.315,934.890419 567.9575,949 522.5,949 C396.055,949 275.3575,899.355176 186.5325,809.994493 C132.1925,755.646476 91.96,689.279185 69.4925,617.163546 L0,617.163546 L0,379.390969 L56.9525,379.390969 C100.8425,163.044053 292.6,0 522.5,0 C647.9,0 768.5975,49.6448238 857.945,139.005507 C924.3025,204.85022 968.715,288.985132 987.0025,379.390969 L1045,379.390969 L1045,614.028084 L1045,614.028084 L1045,615.073238 L1045,617.163546 L1041.865,617.163546 L855.855,788.046256 L578.93,756.69163 L578.93,669.421256 L831.2975,669.421256 L873.62,618.731278 M379.8575,462.480727 C395.5325,462.480727 410.685,468.751652 421.6575,480.248348 C432.63,491.222467 438.9,506.377203 438.9,522.054515 C438.9,537.731828 432.63,552.886564 421.6575,563.860683 C410.685,574.834802 395.5325,581.105727 379.8575,581.105727 C346.94,581.105727 320.2925,554.976872 320.2925,522.054515 C320.2925,489.132159 346.94,462.480727 379.8575,462.480727 M664.62,462.480727 C697.5375,462.480727 723.6625,489.132159 723.6625,522.054515 C723.6625,554.976872 697.5375,581.105727 664.62,581.105727 C631.7025,581.105727 605.055,554.976872 605.055,522.054515 C605.055,489.152821 631.723159,462.480727 664.62,462.480727 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.e1cee9a52e66aba66151aba1d204c140.svg";
export { ForwardRef as ReactComponent };